import styled from 'styled-components';

export const DivAccordionMobile = styled.div`
background: ${({ isDragging }) => isDragging ? '#faf8f8' : '#fff'};
padding: 2rem 2rem;
border-bottom: 1.5px solid rgba(196, 196, 196, 0.4);

@media (max-width: 691px) {
    padding: 2rem 0
}

.switch-mobile {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center !important;
    h4 {
        margin: 0.25rem 0 0 1rem !important;
        padding: 0;
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 550 !important;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        text-align: left;
        color: #2a0709
    }
}


  .td-descricao {
    max-height: 1.4em; 
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; 
    -webkit-box-orient: vertical;
  }


.collapsed-div {
    gap: 2rem;
}

.buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;

    button {
        width: 100%;
        outline: none;
        border: none;
        height: 2.5rem;
        border-radius: 2.5rem;
        font-size: 0.7rem;
        font-weight: 550;
        transition: all 0.2s ease-in-out;
    }

    .red {
        background: var(--red-100);
        color: var(--white);

        :hover {
            background: var(--red-200);
        }

        :active {
            background: var(--red-0);
        }
    }

    .white {
        background: var(--white);
        color: var(--red-200);
        border: 1.5px solid var(--red-200);

        :hover {
            background-color: var(--cor-neutra-100);
        }

        :active {
            background-color: var(--cor-neutra-500);
        }
    }
}

.texts {
    height: 48px;
    width: 100%;
    max-width: 144px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    span {
        font-family: Montserrat;
        font-size: 1rem;
    }
    .title {
        color: #a49b9b;
        font-weight: 400
    }
    .content {
        color: #2a0709;
        font-weight: 600;
        width: 100%;
        max-width: 144px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis
    }

    .content-a-partir-de {
        color: #2a0709;
        font-weight: 600;
        width: 100%;
        max-width: 144px;
        white-space: nowrap;
        text-overflow: ellipsis
    }

    .a-partir-de{
        font-size: 11px;
        color: #321e1d;
        font-weight: 500;            
    }
}

.texts-switch {
    height: 56px;
    width: 100%;
    max-width: 144px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    span {
        font-family: Montserrat;
        font-size: 1rem;
    }
    .title {
        color: #a49b9b;
        font-weight: 400
    }
    .content {
        color: #2a0709;
        font-weight: 600;
        width: 100%;
        max-width: 144px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis
    }
}

.header-collapse {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    .left {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 1rem;
        .prod-img {
            border: 1px solid #dedede;
            opacity: 1;
            filter: grayscale(0);
            transition: all 1s;
            width: 48px;
            height: 48px;
            border-radius: 4px;
            overflow: hidden;
            object-fit: cover;
        }
        .prod-img-gray {
            border: 1px solid #dedede;
            opacity: 0.8;
            filter: grayscale(1);
            transition: all 1s;
            width: 48px;
            height: 48px;
            border-radius: 4px;
            overflow: hidden;
            object-fit: cover;
        }
        .icon-reorder {
            color: #a49b9b;
            width: 1rem;
            height: 1rem;
            font-size: 1rem;
        }
    }

    .right {
        .icon {
            cursor: pointer;
            width: 22px;
            height: 22px;
            .chevron {
                transition: 0.3s transform;
                -webkit-transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
            }
        }
    }
}
`

export const DivAccordion = styled.div`
        white-space: nowrap;
        border-radius: 0.5rem;
        background-color: ${({isDragging}) => isDragging ? 'var(--cor-neutra-100)' : 'var(--white)'};
        cursor: default;
        display: flex;
        width: 50%;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 42px;
        padding-left: 32px;

        @media (max-width: 691px) {
            width: 100%;
            padding: 0.75rem 0 !important;

            .categ-name {
                width: 108px;
            }

            h3 .categoria {
                @media(max-width: 691px) {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }

        div {
            display: flex;
            flex-direction: row
        }

        h4 {
            margin: 0;
            font-family: Montserrat;
            font-size: 16px;
            font-weight: 700;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            overflow: hidden;
            white-space:nowrap;
            text-overflow:ellipsis;
            max-width:50%;
            display:inline-block;
        }

        .icon {
            cursor: pointer;
            width: 22px;
            height: 22px;
            padding: 0 16px;

            @media (max-width: 691px) {
                padding: 0 0.5rem;
            }

            .chevron {
                transition: 0.3s transform;
                -webkit-transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
            }
        }
`

export const StyledTbody = styled.tbody`
    cursor: pointer;
    background-color: ${props => (props.isDragging ? '#faf8f8' : '#fff')};
    :hover {
            background-color: #faf8f8
        }
    tr {
        cursor: pointer;
    }
`